var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSort = function SvgSort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.5 4.013v9.085L7.707 9.305 6.293 10.72l5.5 5.5h1.414l5.5-5.5-1.414-1.415-3.793 3.793V4.013zM14.707 22.707l3.793-3.793V28h2v-9.086l3.793 3.793 1.414-1.414-5.5-5.5h-1.414l-5.5 5.5z"
  })));
};
export default SvgSort;